import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private forgotPasswordSubject = new Subject<{
    isForgot: boolean;
    isLogin: boolean;
    isSesion: boolean;
    isBlocked: boolean;
  }>();
  private dataLoginForgot = new Subject<Object>();
  private dataRestoreLoginForgot = new Subject<Object>();

  forgotPassword$ = this.forgotPasswordSubject.asObservable();
  dataLoginForgot$ = this.dataLoginForgot.asObservable();
  dataRestoreLoginForgot$ = this.dataRestoreLoginForgot.asObservable();

  save(username: string, nombre: string, apellido: string, img: any): void {
    const sessions = this.getRecents();
    sessionStorage.setItem('username', username);
    if (sessions) {
      if (sessions.length >= 4) {
        sessions[3] = {
          username,
          nombre,
          apellido,
          img,
        };
        localStorage.setItem('sessions', JSON.stringify(sessions));
      } else {
        const index = _.findIndex(sessions, { username: username });
        if (index < 0) {
          sessions[sessions.length] = {
            username,
            nombre,
            apellido,
            img,
          };
          localStorage.setItem('sessions', JSON.stringify(sessions));
        } else {
          sessions[index] = {
            username,
            nombre,
            apellido,
            img,
          };
          localStorage.setItem('sessions', JSON.stringify(sessions));
        }
      }
    } else {
      const ses = [];
      ses.push({
        username,
        nombre,
        apellido,
        img,
      });
      localStorage.setItem('sessions', JSON.stringify(ses));
    }
  }

  update(username: string, nombre: string, apellido: string, img: any): void {
    const sessions = this.getRecents();
    const index = _.findIndex(sessions, { username: username });
    sessions[index] = {
      username: username,
      nombre: nombre,
      apellido: apellido,
      img: img,
    };
    localStorage.setItem('sessions', JSON.stringify(sessions));
  }

  getRecents(): any[] {
    const sessions = localStorage.getItem('sessions');
    return sessions ? JSON.parse(sessions) : [];
  }

  getSession(username: string): any {
    const sessions = this.getRecents();
    const index = _.findIndex(sessions, { username: username });
    if (index < 0) {
      return undefined;
    }
    return sessions[index];
  }

  delete(index: number): void {
    const sessions = this.getRecents();
    sessions.splice(index, 1);
    localStorage.setItem('sessions', JSON.stringify(sessions));
  }

  //Servicio auxiliar para comunicacion Login & ForgotPassword

  updateForgotPasswordStatus(
    isForgot: boolean,
    isLogin: boolean,
    isSesion: boolean,
    isBlocked: boolean,
  ) {
    setTimeout(() => {
      this.forgotPasswordSubject.next({
        isForgot,
        isLogin,
        isSesion,
        isBlocked,
      });
    }, 2000);
  }

  saveDataLoginForgot(data: Object) {
    setTimeout(() => {
      this.dataLoginForgot.next(data);
    }, 2000);
  }

  restoreDataLoginForgot(data: Object) {
    setTimeout(() => {
      this.dataRestoreLoginForgot.next(data);
    }, 2000);
  }
}
